import React, { useState } from 'react';

import { Suggest } from '.';
import { ISuggestProps } from './types';

type INameSuggestProps<T> = Pick<ISuggestProps<T>, 'input' | 'onBlur' | 'onChange' | 'onFocus' | 'onSelect'>;

export const JobTitleSuggest = (props: INameSuggestProps<string>) => {
    const { onChange = () => null } = props;
    const [list, setList] = useState(jobs);

    const onChangeHandler: typeof props['onChange'] = (event) => {
        const {
            target: { value },
        } = event;
        const filtered = value ? jobs.filter((item) => item.toLowerCase().includes(value.toLowerCase())) : jobs;
        setList(filtered);
        onChange(event);
    };

    return (
        <Suggest<string>
            {...props}
            options={list}
            onlyList={false}
            onlyRus
            onChange={onChangeHandler}
            mapperOption={(option) => ({ name: option, value: option, option })}
        />
    );
};

const jobs = [
    'ИТ-Директор',
    'Автокрановщик',
    'Автоэлектрик',
    'Агент',
    'Агроном',
    'Адвокат',
    'Администратор',
    'Аккумуляторщик',
    'Актер',
    'Акушер',
    'Альпинист',
    'Аналитик',
    'Аппаратчик',
    'Арматурщик',
    'Арт-Директор',
    'Артист',
    'Архивариус',
    'Архитектор',
    'Ассистент',
    'Аудитор',
    'Аукционист',
    'Байер',
    'Балансировщик',
    'Бариста',
    'Бармен',
    'Бетонщик',
    'Библиотекарь',
    'Бизнес-Тренер',
    'Биржевой',
    'Боец Скота',
    'Бортпроводник',
    'Бренд-Менеджер',
    'Бригадир',
    'Брокер',
    'Бункеровщик',
    'Бурильщик',
    'Буфетчица',
    'Бухгалтер',
    'Вальщик',
    'Варщик',
    'Вахтер',
    'Верстальщик',
    'Ветеринар',
    'Взрывник',
    'Визажист',
    'Винильщик',
    'Вице Президент',
    'Водитель',
    'Водолаз',
    'Военнослужащий',
    'Воспитатель',
    'Врач',
    'Выжигальщик',
    'Газовщик',
    'Газогенераторщик',
    'Газорезчик',
    'Газоспасатель',
    'Гальваник',
    'Гардеробщик',
    'Гендиректор',
    'Генераторщик',
    'Геодезист',
    'Геолог',
    'Геофизик',
    'Гидролог',
    'Гидрометрист',
    'Глава',
    'Главный Бухгалтер',
    'Гладильщик',
    'Горничная',
    'Горнорабочий',
    'Грузчик',
    'Дактилолог',
    'Дежурный',
    'Дезактиваторщик',
    'Декларант',
    'Делопроизводитель',
    'Демонстратор',
    'Дефектоскопист',
    'Диагност',
    'Диджей',
    'Дизайнер',
    'Дилер',
    'Директор',
    'Директор Аптеки',
    'Директор Клуба',
    'Директор Магазина',
    'Директор Парка',
    'Директор по Качеству',
    'Директор по Маркетингу',
    'Директор по Персоналу',
    'Директор по Продажам',
    'Директор Производства',
    'Директор Ресторана',
    'Директор Филиала',
    'Директор Школы',
    'Диспетчер',
    'Дневальный',
    'Доводчик',
    'Дозиметрист',
    'Дознаватель',
    'Документовед',
    'Донкерман',
    'Досмотровый',
    'Доцент',
    'Доярка',
    'Дробильщик',
    'Егерь',
    'Жестянщик',
    'Зав. Складом',
    'Заведующая',
    'Заведующая Аптекой',
    'Заведующая Детсадом',
    'Заведующая Магазином',
    'Заведующая Общежитием',
    'Заведующая Отделением',
    'Заведующая Производством',
    'Заведующая Филиалом',
    'Заведующий',
    'Заведующий Кассой',
    'Заведующий Кафедрой',
    'Заведующий Музеем',
    'Заведующий Отделением',
    'Заведующий Поликлиникой',
    'Заведующий Производством',
    'Заведующий Сектором',
    'Заведующий Складом',
    'Заведующий Хозяйством',
    'Завуч',
    'Завхоз',
    'Закройщик',
    'Замерщик',
    'Заместитель',
    'Заместитель Бухгалтера',
    'Заместитель Гендиректора',
    'Заместитель Директора',
    'Заместитель Директора',
    'Заместитель Заведующего',
    'Заместитель Инженера',
    'Заместитель Командира',
    'Заместитель Начальника',
    'Заместитель Председателя',
    'Заместитель Прокурора',
    'Заместитель Руководителя',
    'Заместитель Управляющего',
    'Зарядчик',
    'Заточник',
    'Звукорежиссер',
    'Земледел',
    'Землекоп',
    'Зоотехник',
    'Зуборезчик',
    'Изготовитель',
    'Изолировщик',
    'Инженер',
    'Инкассатор',
    'Инспектор',
    'Инструктор',
    'Исполнительный Директор',
    'Испытатель',
    'Исследователь',
    'Калькулятор',
    'Каменщик',
    'Капитан',
    'Кассир',
    'Кастелянша',
    'Категорийнный Менеджер',
    'Кинолог',
    'Кладовщик',
    'Клеевар',
    'Кодификатор',
    'Командир',
    'Командир Батальона',
    'Командир Взвода',
    'Командир Группы',
    'Командир Отделения',
    'Командир Роты',
    'Комендант',
    'Коммерческий Директор',
    'Коммивояжер',
    'Комплектовщик',
    'Композитор',
    'Кондитер',
    'Кондуктор',
    'Консервировщик',
    'Конструктор',
    'Консультант',
    'Консьерж',
    'Контрактный Управляющий',
    'Контролер',
    'Концертмейстер',
    'Координатор',
    'Копирайтер',
    'Копировщик',
    'Копровщик',
    'Корреспондент',
    'Косметолог',
    'Котельщик',
    'Котлочист',
    'Кочегар',
    'Кровельщик',
    'Крупье',
    'Кузнец',
    'Курьер',
    'Лаборант',
    'Лебедчик',
    'Лесничий',
    'Лесоруб',
    'Лифтер',
    'Логист',
    'Маклер',
    'Маляр',
    'Маркетолог',
    'Маркировщик',
    'Маркшейдер',
    'Маскировщик',
    'Массажист',
    'Мастер',
    'Математик',
    'Матрос',
    'Машинист',
    'Машинистка',
    'Медбрат',
    'Медрегистратор',
    'Медсестра',
    'Менеджер',
    'Менеджер по Закупкам',
    'Менеджер по Персоналу',
    'Менеджер по Продажам',
    'Менеджер по Работе с ключевыми клиентами',
    'Менеджер по Рекламе',
    'Менеджер по Туризму',
    'Менеджер Проекта',
    'Мерчендайзер',
    'Металлизатор',
    'Методист',
    'Методолог',
    'Метрдотель',
    'Метролог',
    'Механизатор',
    'Механик',
    'Модельщик',
    'Мойщик',
    'Монтажник',
    'Монтер',
    'Моторист',
    'Музыкант',
    'Мясник',
    'Наладчик',
    'Наполнитель',
    'Нарядчик',
    'Настоятель',
    'Начальник',
    'Начальник Аппаратной',
    'Начальник Бюро',
    'Начальник Гаража',
    'Начальник Группы',
    'Начальник Караула',
    'Начальник Колонны',
    'Начальник Лаборатории',
    'Начальник Отдела',
    'Начальник Отделения',
    'Начальник Охраны',
    'Начальник Производства',
    'Начальник Сектора',
    'Начальник Склада',
    'Начальник Службы',
    'Начальник Смены',
    'Начальник Управления',
    'Начальник Участка',
    'Начальник Цеха',
    'Начальник Штаба',
    'Нейтрализаторщик',
    'Носильщик',
    'Обойщик',
    'Обрубщик',
    'Обходчик',
    'Огнеупорщик',
    'Окорщик',
    'Оператор',
    'Операционист',
    'Оперуполномоченный',
    'Опиловщик',
    'Осмотрщик',
    'Ответственный',
    'Отделочник',
    'Офис-Менеджер',
    'Официант',
    'Охотовед',
    'Охранник',
    'Оценщик',
    'Парикмахер',
    'Парковщик',
    'Паяльщик',
    'Певец',
    'Педагог',
    'Педиатр',
    'Пекарь',
    'Переводчик',
    'Переработчик',
    'Пескоструйщик',
    'Печатник',
    'Пиар-Менеджер',
    'Пилот',
    'Пирометрист',
    'Писатель',
    'Плавильщик',
    'Планиметрист',
    'Плотник',
    'Повар',
    'Подсобный',
    'Пожарный',
    'Полировщик',
    'Полицейский',
    'Помощник',
    'Помощник Директора',
    'Портной',
    'Портье',
    'Посудомойщица',
    'Почтальон',
    'Председатель',
    'Председатель Правления',
    'Представитель',
    'Президент',
    'Преподаватель',
    'Прессовщик',
    'Пресс-Секретарь',
    'Приемосдатчик',
    'Приемщик',
    'Пристав',
    'Пробоотборщик',
    'Провизор',
    'Программист',
    'Продавец',
    'Продакт-Менеджер',
    'Продюсер',
    'Проектировщик',
    'Производитель',
    'Промоутер',
    'Промышленный',
    'Пропитчик',
    'Прораб',
    'Проректор',
    'Профконсультант',
    'Проходчик',
    'Психолог',
    'Работник',
    'Рабочий',
    'Радиомеханик',
    'Радиомонтажник',
    'Радиомонтер',
    'Разметчик',
    'Разнорабочий',
    'Разработчик',
    'Раскройщик',
    'Раскряжевщик',
    'Распределитель',
    'Ревизор',
    'Регенераторщик',
    'Региональный Директор',
    'Региональный Менеджер',
    'Регулировщик',
    'Редактор',
    'Резчик',
    'Ректор',
    'Ремонтировщик',
    'Ресепшионист',
    'Реставратор',
    'Ретушер',
    'Референт',
    'Рефмеханик',
    'Риелтор',
    'Рубщик',
    'Руководитель',
    'Руководитель Бюро',
    'Руководитель Группы',
    'Руководитель Департамента',
    'Руководитель Кружка',
    'Руководитель Магазина',
    'Руководитель Направления',
    'Руководитель Отдела',
    'Руководитель Отдела',
    'Руководитель Проекта',
    'Руководитель Производства',
    'Руководитель СБ',
    'Руководитель Службы',
    'Руководитель Строительства',
    'Руководитель Студии',
    'Руководитель Управления',
    'Руководитель Участка',
    'Руководитель Филиала',
    'Санитар',
    'Сантехник',
    'Сборщик',
    'Сварщик',
    'Сверловщик',
    'Светокопировщик',
    'Священник',
    'Секретарь',
    'Сиделка',
    'Системный Администратор',
    'Следователь',
    'Слесарь',
    'Сливщик',
    'Смазчик',
    'Сметчик',
    'Снабженец',
    'Советник',
    'Солист',
    'Сортировщик',
    'Составитель',
    'Сотрудник',
    'Социальный Работник',
    'Социолог',
    'Спасатель',
    'Специалист',
    'Сплотчик',
    'Спортсмен',
    'Станочник',
    'Старший Смены',
    'Старшина',
    'Статистик',
    'Стенографистка',
    'Стерженщик',
    'Стилист',
    'Столяр',
    'Стоматолог',
    'Сторож',
    'Стрелок',
    'Строгальщик',
    'Строитель',
    'Стропальщик',
    'Судья',
    'Супервайзер',
    'Сушильщик',
    'Табельщик',
    'Такелажник',
    'Таксировщик',
    'Таксист',
    'Танцовщица',
    'Телеоператор',
    'Телохранитель',
    'Терапевт',
    'Термист',
    'Территориальный Менеджер',
    'Тестировщик',
    'Тестовод',
    'Техник',
    'Технический Директор',
    'Технолог',
    'Товаровед',
    'Токарь',
    'Точковщик',
    'Тракторист',
    'Транспортерщик',
    'Транспортировщик',
    'Тренер',
    'Тренинг',
    'Трубочист',
    'Уборщик',
    'Укладчик',
    'Упаковщик',
    'Управляющая',
    'Управляющая Магазином',
    'Управляющий',
    'Управляющий Автопарком',
    'Управляющий Магазином',
    'Управляющий Отделом',
    'Управляющий Рестораном',
    'Управляющий Школы',
    'Установщик',
    'Участковый',
    'Учетчик',
    'Учитель',
    'Фармацевт',
    'Фасовщик',
    'Фельдшер',
    'Физиолог',
    'Финансовый Директор',
    'Фитнес-Тренер',
    'Флорист',
    'Формировщик',
    'Формовщик',
    'Форсунщик',
    'Фотограф',
    'Фрезеровщик',
    'Фурнитурщик',
    'Футболист',
    'Химик',
    'Хирург',
    'Хронометражист',
    'Художник',
    'Чертежник',
    'Чистильщик',
    'Чокеровщик',
    'Швейцар',
    'Швея',
    'Шиномонтажник',
    'Шихтовщик',
    'Шлифовщик',
    'Штабелевщик',
    'Штемпелевщик',
    'Штукатур',
    'Экономист',
    'Экскаваторщик',
    'Экскурсовод',
    'Экспедитор',
    'Эксперт',
    'Электрик',
    'Электрогазосварщик',
    'Электромеханик',
    'Электромонтажник',
    'Электромонтёр',
    'Электросварщик',
    'Электрослесарь',
    'Электрофотограф',
    'Электроэрозионист',
    'Эмульсовар',
    'Энергетик',
    'Ювелир',
    'Юрисконсульт',
    'Юрист',
    'Автомеханик',
    'Автослесарь',
    'Ведущий Инженер',
    'Ведущий Менеджер',
    'Ведущий Специалист',
    'Водитель Автобуса',
    'Водитель Погрузчика',
    'Водитель Такси',
    'Водитель Экспедитор',
    'Газоэлектросварщик',
    'Главный Инженер',
    'Главный Механик',
    'Главный Специалист',
    'Главный Энергетик',
    'Дворник',
    'Директор по Развитию',
    'Дорожный Мастер',
    'Дорожный Рабочий',
    'Инженер-Механик',
    'Инспектор ДПС',
    'Крановщик',
    'Литейщик',
    'Мастер Маникюра',
    'Мастер Производства',
    'Мастер Смены',
    'Мастер Участка',
    'Мастер Цеха',
    'Машинист Бульдозера',
    'Машинист Крана',
    'Машинист Тепловоза',
    'Машинист Экскаватора',
    'Менеджер Отдела',
    'Младший Инспектор',
    'Монтер Пути',
    'Научный Сотрудник',
    'Оперативный Дежурный',
    'Оператор АЗС',
    'Оператор Котельной',
    'Оператор Станка',
    'Погрузчик',
    'Подсобный Рабочий',
    'Полицейский Водитель',
    'Помощник Руководителя',
    'Помощник Бурильщика',
    'Помощник Бухгалтера',
    'Помощник Машиниста',
    'Помощник Начальника',
    'Помощник Руководителя',
    'Помощник Судьи',
    'Помощник Юриста',
    'Продавец Кассир',
    'Продавец-Консультант',
    'Продавец-Кассир',
    'Производитель Работ',
    'Сборщик Мебели',
    'Связист',
    'Сервисный Инженер',
    'Скотник',
    'Слесарь-Монтажник',
    'Слесарь-Ремонтник',
    'Слесарь-Сантехник',
    'Слесарь-Сборщик',
    'Служба Безопасности',
    'Специалист по Кадрам',
    'Старшая Медсестра',
    'Старший Администратор',
    'Старший Бухгалтер',
    'Старший Инженер',
    'Старший Инспектор',
    'Старший Кассир',
    'Старший Кладовщик',
    'Старший Контролер',
    'Старший Мастер',
    'Старший Менеджер',
    'Старший Механик',
    'Старший Оператор',
    'Старший Охранник',
    'Старший Продавец',
    'Старший Специалист',
    'Страховой Агент',
    'Судебный Пристав',
    'Торговый Представитель',
    'Шеф-Повар',
    'Регистратор',
    'Учредитель',
    'Заведующий Аптекой',
    'Заведующий Детсадом',
    'Заведующий Магазином',
    'Заведующий Общежитием',
    'Посудомойщик',
    'Заведующий Филиалом',
    'Финансист',
    'Гувернантка',
    'Айти-Директор',
    'Нотариус',
];
